// Configuração do Mercado Pago
import { MercadoPagoConfig } from 'mercadopago';

// Configuração das credenciais
// IMPORTANTE: Substitua pelas suas credenciais do Mercado Pago
const mercadoPagoConfig = {
  // Use as credenciais de teste durante o desenvolvimento
  accessToken: import.meta.env.VITE_MERCADO_PAGO_ACCESS_TOKEN || 'TEST-YOUR-ACCESS-TOKEN-HERE',
  publicKey: import.meta.env.VITE_MERCADO_PAGO_PUBLIC_KEY || 'TEST-YOUR-PUBLIC-KEY-HERE',
  // Para produção, use as credenciais reais
  isProduction: import.meta.env.MODE === 'production'
};

// Validar se as credenciais estão configuradas
if (!mercadoPagoConfig.accessToken || mercadoPagoConfig.accessToken === 'TEST-YOUR-ACCESS-TOKEN-HERE') {
  console.warn('⚠️ Credenciais do Mercado Pago não configuradas corretamente!');
}

if (!mercadoPagoConfig.publicKey || mercadoPagoConfig.publicKey === 'TEST-YOUR-PUBLIC-KEY-HERE') {
  console.warn('⚠️ Chave pública do Mercado Pago não configurada corretamente!');
}

// Inicializar cliente do Mercado Pago
const client = new MercadoPagoConfig({
  accessToken: mercadoPagoConfig.accessToken,
  options: {
    timeout: 5000,
    idempotencyKey: 'abc'
  }
});

// Configurações de produtos/planos
export const SUBSCRIPTION_PLANS = {
  premium: {
    id: 'premium',
    title: 'OverPixel Premium',
    description: 'Acesso completo a todos os recursos premium',
    price: 29.90,
    currency: 'BRL',
    features: [
      'Download ilimitado de recursos',
      'Acesso a cursos premium',
      'Suporte prioritário',
      'Armazenamento de 5GB',
      'Sem anúncios'
    ],
    duration: 'monthly' // monthly, yearly
  },
  enterprise: {
    id: 'enterprise',
    title: 'OverPixel Enterprise',
    description: 'Solução completa para empresas',
    price: 99.90,
    currency: 'BRL',
    features: [
      'Todos os recursos Premium',
      'Licenças para equipe',
      'API personalizada',
      'Armazenamento ilimitado',
      'Suporte 24/7',
      'Relatórios avançados'
    ],
    duration: 'monthly'
  }
};

export { client, mercadoPagoConfig };
export default client;